import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err);
};

const vuerouter = new Router({
  mode: "history", //去掉#号
  routes: [
    {
      path: "/",
      name: "login",
      component: resolve => require(["../components/login"], resolve)
    },
    {
      path: "/WaiBuJinJian",
      name: "WaiBuJinJian",
      component: resolve =>
        require(["../components/jinjian/JinJian.vue"], resolve)
    },
    {
      path: "/home",
      name: "home",
      component: resolve => require(["../components/home/index.vue"], resolve),
      children: [
        // 支付控台
        {
          path: "pay",
          name: "pay",
          component: resolve =>
            require(["../components/pay/root.vue"], resolve),
          children: [
            {
              path: "index",
              name: "payindex",
              meta: { title: "主页", id: "0" },
              component: resolve =>
                require(["../components/pay/index.vue"], resolve)
            },
            {
              path: "statistics",
              name: "paystatistics",
              meta: { title: "月度统计", id: "1" },
              component: resolve =>
                require(["../components/pay/statistics.vue"], resolve)
            },
            // 商户
            {
              path: "shanghuLiebiao",
              name: "payshanghuLiebiao",
              meta: { title: "商户列表", id: "3" },
              component: resolve =>
                require([
                  "../components/pay/ShangHu/shanghu-liebiao.vue"
                ], resolve)
            },
            {
              path: "ZiShangHuLieBiao",
              name: "payZiShangHuLieBiao",
              meta: { title: "子商户列表", id: "40" },
              component: resolve =>
                require([
                  "../components/pay/ShangHu/ZiShangHuLieBiao.vue"
                ], resolve)
            },
            // {
            //   path: "shanghuLiebiaoXZ",
            //   name: "payshanghuLiebiaoXZ",
            //   meta: { title: "商户新增", id: "3" },
            //   component: resolve =>
            //     require([
            //       "../components/pay/ShangHu/shanghu-liebiao-xz.vue"
            //     ], resolve)
            // },
            // {
            //   path: "shanghuLiebiaoBj",
            //   name: "payshanghuLiebiaoBj",
            //   meta: { title: "商户编辑", id: "3" },
            //   component: resolve =>
            //     require([
            //       "../components/pay/ShangHu/shanghu-liebiao-bj.vue"
            //     ], resolve)
            // },
            // {
            //   path: "TongDaolLieBiao",
            //   name: "payTongDaolLieBiao",
            //   meta: { title: "通道列表", id: "3" },
            //   component: resolve =>
            //     require([
            //       "../components/pay/ShangHu/TongDaolLieBiao.vue"
            //     ], resolve)
            // },
            {
              path: "zishanghu",
              name: "payzishanghu",
              meta: { title: "子商户列表", id: "3" },
              component: resolve =>
                require(["../components/pay/ShangHu/zishanghu.vue"], resolve)
            },
            {
              path: "ShangHuShangHuFenZhang",
              name: "payShangHuShangHuFenZhang",
              meta: { title: "商户分账", id: "3" },
              component: resolve =>
                require([
                  "../components/pay/ShangHu/ShangHuFenZhang.vue"
                ], resolve)
            },
            {
              path: "ShangHuZiShangHuFenZhang",
              name: "payShangHuZiShangHuFenZhang",
              meta: { title: "子商户分账", id: "3" },
              component: resolve =>
                require([
                  "../components/pay/ShangHu/ZiShangHuFenZhang.vue"
                ], resolve)
            },
            {
              path: "ShangHuFeiLv",
              name: "payShangHuFeiLv",
              meta: { title: "费率列表", id: "3" },
              component: resolve =>
                require(["../components/pay/ShangHu/FeiLv.vue"], resolve)
            },
            {
              path: "shanghuLiushui",
              name: "payshanghuLiushui",
              meta: { title: "实时流水", id: "4" },
              component: resolve =>
                require([
                  "../components/pay/ShangHu/shanghu-liushui.vue"
                ], resolve)
            },
            {
              path: "shanghuFengZhangLiuShui",
              name: "payshanghuFengZhangLiuShui",
              meta: { title: "分账流水", id: "23" },
              component: resolve =>
                require([
                  "../components/pay/ShangHu/FengZhangLiuShui.vue"
                ], resolve)
            },
            {
              path: "shanghuTiXianJiLu",
              name: "payshanghuTiXianJiLu",
              meta: { title: "提现记录", id: "24" },
              component: resolve =>
                require(["../components/pay/ShangHu/TiXianJiLu.vue"], resolve)
            },
            {
              path: "ShangHuMeiRiShuJv",
              name: "payShangHuMeiRiShuJv",
              meta: { title: "机构每日数据", id: "35" },
              component: resolve =>
                require(["../components/pay/ShangHu/MeiRiShuJv.vue"], resolve)
            },
            {
              path: "ShangHuMeiRiShuJvTwo",
              name: "payShangHuMeiRiShuJvTwo",
              meta: { title: "商户每日数据", id: "36" },
              component: resolve =>
                require([
                  "../components/pay/ShangHu/ShangHuMeiRiShuJv.vue"
                ], resolve)
            },
            {
              path: "ShangHuTouSuTongJi",
              name: "payShangHuTouSuTongJi",
              meta: { title: "投诉统计", id: "39" },
              component: resolve =>
                require(["../components/pay/ShangHu/TouSuTongJi.vue"], resolve)
            },
            // 支付
            {
              path: "ZhiFuJiGou",
              name: "payZhiFuJiGou",
              meta: { title: "支付机构", id: "10" },
              component: resolve =>
                require(["../components/pay/ZhiFu/JiGou.vue"], resolve)
            },
            {
              path: "TongDaoLieBiao",
              name: "payZhiTongDaoLieBiao",
              meta: { title: "通道列表", id: "10" },
              component: resolve =>
                require(["../components/pay/ZhiFu/TongDaoLieBiao.vue"], resolve)
            },
            {
              path: "ZhiFuFangShi",
              name: "payZhiFuFangShi",
              meta: { title: "支付方式", id: "11" },
              component: resolve =>
                require(["../components/pay/ZhiFu/FangShi.vue"], resolve)
            },
            {
              path: "ZhiFuShangHu",
              name: "payZhiFuShangHu",
              meta: { title: "支付商户", id: "14" },
              component: resolve =>
                require(["../components/pay/ZhiFu/ShangHu.vue"], resolve)
            },
            {
              path: "ZhiFuFenZhang",
              name: "payZhiFuFenZhang",
              meta: { title: "分账账号", id: "15" },
              component: resolve =>
                require(["../components/pay/ZhiFu/FenZhang.vue"], resolve)
            },
            {
              path: "FenZhangJiLi",
              name: "payFenZhangJiLi",
              meta: { title: "分账记录", id: "16" },
              component: resolve =>
                require(["../components/pay/ZhiFu/FenZhangJiLi.vue"], resolve)
            },
            // 订单
            {
              path: "DingDanZhiFu",
              name: "payDingDanZhiFu",
              meta: { title: "支付订单", id: "8" },
              component: resolve =>
                require(["../components/pay/DingDan/ZhiFu.vue"], resolve)
            },
            {
              path: "DingDanTuiKuan",
              name: "payDingDanTuiKuan",
              meta: { title: "退款订单", id: "9" },
              component: resolve =>
                require(["../components/pay/DingDan/TuiKuan.vue"], resolve)
            },
            {
              path: "DingDanTouSu",
              name: "payDingDanTouSu",
              meta: { title: "投诉订单", id: "13" },
              component: resolve =>
                require(["../components/pay/DingDan/TouSu.vue"], resolve)
            },
            {
              path: "FenZhangDingDan",
              name: "payFenZhangDingDan",
              meta: { title: "分账订单", id: "25" },
              component: resolve =>
                require([
                  "../components/pay/DingDan/FenZhangDingDan.vue"
                ], resolve)
            },
            {
              path: "TuiFenZhangDingDan",
              name: "payTuiFenZhangDingDan",
              meta: { title: "退分账订单", id: "26" },
              component: resolve =>
                require([
                  "../components/pay/DingDan/TuiFenZhangDingDan.vue"
                ], resolve)
            },
            // 易宝
            {
              path: "YiBaoWeiXinBaoBei",
              name: "payYiBaoWeiXinBaoBei",
              meta: { title: "异主体列表", id: "12" },
              component: resolve =>
                require(["../components/pay/YiBao/WeiXinBaoBei.vue"], resolve)
            },
            {
              path: "YiBaoYiZhuTi",
              name: "payYiBaoYiZhuTi",
              meta: { title: "异主体操作", id: "37" },
              component: resolve =>
                require(["../components/pay/YiBao/YiZhuTi.vue"], resolve)
            },
            {
              path: "YiBaoYiZhuTi2",
              name: "payYiBaoYiZhuTi2",
              meta: { title: "异主体操作(全部)", id: "38" },
              component: resolve =>
                require(["../components/pay/YiBao/YiZhuTi2.vue"], resolve)
            },
            // 系统
            {
              path: "XiTongGuanLiYuan",
              name: "payXiTongGuanLiYuan",
              meta: { title: "管理员列表", id: "17" },
              component: resolve =>
                require(["../components/pay/XiTong/GuanLiYuan.vue"], resolve)
            },
            {
              path: "XiTongRiZhi",
              name: "payXiTongRiZhi",
              meta: { title: "操作日志", id: "18" },
              component: resolve =>
                require(["../components/pay/XiTong/RiZhi.vue"], resolve)
            },
            {
              path: "XiTongJueSe",
              name: "payXiTongJueSe",
              meta: { title: "角色列表", id: "20" },
              component: resolve =>
                require(["../components/pay/XiTong/JueSe.vue"], resolve)
            },
            {
              path: "XiTongQuanXian",
              name: "payXiTongQuanXian",
              meta: { title: "权限列表", id: "21" },
              component: resolve =>
                require(["../components/pay/XiTong/QuanXian.vue"], resolve)
            },
            // 下载中心
            {
              path: "XiaZaiIndex",
              name: "payXiaZaiIndex",
              meta: { title: "下载中心", id: "22" },
              component: resolve =>
                require(["../components/pay/XiaZai/index.vue"], resolve)
            },
            // 公告列表
            {
              path: "GongGaoIndex",
              name: "payGongGaoIndex",
              meta: { title: "公告列表", id: "27" },
              component: resolve =>
                require(["../components/pay/GongGao/index.vue"], resolve)
            },
            // 验证码列表
            {
              path: "YanZhengMa",
              name: "payYanZhengMa",
              meta: { title: "验证码列表", id: "28" },
              component: resolve =>
                require([
                  "../components/pay/FuZhuGongNeng/YanZhengMa.vue"
                ], resolve)
            },
            // 代理商
            {
              path: "DaiLieShangLieBiao",
              name: "payDaiLieShangLieBiao",
              meta: { title: "代理商列表", id: "29" },
              component: resolve =>
                require([
                  "../components/pay/DailiShang/DaiLieShangLieBiao.vue"
                ], resolve)
            },
            {
              path: "DaiLieShangTiXianJiLu",
              name: "payDaiLieShangTiXianJiLu",
              meta: { title: "提现记录", id: "30" },
              component: resolve =>
                require([
                  "../components/pay/DailiShang/TiXianJiLu.vue"
                ], resolve)
            },
            {
              path: "DaiLieShangLiuShuiLieBiao",
              name: "payDaiLieShangLiuShuiLieBiao",
              meta: { title: "流水列表", id: "31" },
              component: resolve =>
                require([
                  "../components/pay/DailiShang/LiuShuiLieBiao.vue"
                ], resolve)
            },
            {
              path: "DaiLieShangTiXianShangHu",
              name: "payDaiLieShangTiXianShangHu",
              meta: { title: "提现账户列表", id: "32" },
              component: resolve =>
                require([
                  "../components/pay/DailiShang/TiXianShangHu.vue"
                ], resolve)
            },
            // {
            //   path: "DaiLieShangFeiLv",
            //   name: "payDaiLieShangFeiLv",
            //   meta: { title: "费率列表", id: "33" },
            //   component: resolve =>
            //     require(["../components/pay/DailiShang/FeiLv.vue"], resolve)
            // },
            {
              path: "DaiLieShangXiaJiShangHu",
              name: "payDaiLieShangXiaJiShangHu",
              meta: { title: "下级商户列表", id: "34" },
              component: resolve =>
                require([
                  "../components/pay/DailiShang/XiaJiShangHu.vue"
                ], resolve)
            },
            {
              path: "FuZhuGongNengKeHuChi",
              name: "payFuZhuGongNengKeHuChi",
              meta: { title: "客户池管理", id: "41" },
              component: resolve =>
                require([
                  "../components/pay/FuZhuGongNeng/KeHuChi.vue"
                ], resolve)
            },
            {
              path: "YiBaoShangMengBaoBeiHao",
              name: "payYiBaoShangMengBaoBeiHao",
              meta: { title: "商盟报备号", id: "42" },
              component: resolve =>
                require([
                  "../components/pay/YiBao/ShangMengBaoBeiHao.vue"
                ], resolve)
            },
            {
              path: "YiBaoZhiFuBaoBeiHao",
              name: "payYiBaoZhiFuBaoBeiHao",
              meta: { title: "智付报备号", id: "43" },
              component: resolve =>
                require(["../components/pay/YiBao/ZhiFuBaoBeiHao.vue"], resolve)
            },
            {
              path: "YiBaoKunPengBaoBeiHao",
              name: "payYiBaoKunPengBaoBeiHao",
              meta: { title: "鲲鹏报备号", id: "45" },
              component: resolve =>
                require([
                  "../components/pay/YiBao/KunPengBaoBeiHao.vue"
                ], resolve)
            },
            {
              path: "FuZhuGongNengTeYueShangHu",
              name: "payFuZhuGongNengTeYueShangHu",
              meta: { title: "特约商户管理", id: "44" },
              component: resolve =>
                require([
                  "../components/pay/FuZhuGongNeng/TeYueShangHu.vue"
                ], resolve)
            },
            {
              path: "YiBaoFuYouBaoBeiHao",
              name: "payYiBaoFuYouBaoBeiHao",
              meta: { title: "富有token报备号", id: "46" },
              component: resolve =>
                require(["../components/pay/YiBao/FuYouBaoBeiHao.vue"], resolve)
            },
            {
              path: "HuaTongYinHangZiJinTiXianJiLu",
              name: "payHuaTongYinHangZiJinTiXianJiLu",
              meta: { title: "资金提现记录", id: "48" },
              component: resolve =>
                require([
                  "../components/pay/HuaTongYinHang/ZiJinTiXianJiLu.vue"
                ], resolve)
            },
            {
              path: "HuaTongYinHangZhangHaoFengZhang",
              name: "payHuaTongYinHangZhangHaoFengZhang",
              meta: { title: "账号分账记录", id: "49" },
              component: resolve =>
                require([
                  "../components/pay/HuaTongYinHang/ZhangHaoFengZhang.vue"
                ], resolve)
            },
            {
              path: "HuaTongYinHangZiJinTiHuiJiLu",
              name: "payHuaTongYinHangZiJinTiHuiJiLu",
              meta: { title: "资金提回记录", id: "50" },
              component: resolve =>
                require([
                  "../components/pay/HuaTongYinHang/ZiJinTiHuiJiLu.vue"
                ], resolve)
            },
            {
              path: "HuaTongYinHangShangHuLieBiao",
              name: "payHuaTongYinHangShangHuLieBiao",
              meta: { title: "商户列表", id: "51" },
              component: resolve =>
                require([
                  "../components/pay/HuaTongYinHang/ShangHuLieBiao.vue"
                ], resolve)
            },
            {
              path: "HuaTongYinHangFengZhangFang",
              name: "payHuaTongYinHangFengZhangFang",
              meta: { title: "分账方列表", id: "52" },
              component: resolve =>
                require([
                  "../components/pay/HuaTongYinHang/FengZhangFang.vue"
                ], resolve)
            },
            {
              path: "DingDanDaiFu",
              name: "DingDanDaiFu",
              meta: { title: "代付订单", id: "53" },
              component: resolve =>
                require(["../components/pay/DingDan/DaiFu.vue"], resolve)
            },
            {
              path: "ShangHuKunPengYueTongJi",
              name: "ShangHuKunPengYueTongJi",
              meta: { title: "鲲鹏商户月统计", id: "54" },
              component: resolve =>
                require([
                  "../components/pay/ShangHu/KunPengYueTongJi.vue"
                ], resolve)
            },
            {
              path: "FuZhuGongNengGuangGaoTongJi",
              name: "FuZhuGongNengGuangGaoTongJi",
              meta: { title: "广告日统计", id: "55" },
              component: resolve =>
                require([
                  "../components/pay/FuZhuGongNeng/GuangGaoTongJi.vue"
                ], resolve)
            },
            {
              path: "DailiShangFengRunMingXi",
              name: "DailiShangFengRunMingXi",
              meta: { title: "分润明细", id: "56" },
              component: resolve =>
                require([
                  "../components/pay/DailiShang/FengRunMingXi.vue"
                ], resolve)
            },
            {
              path: "DailiShangFengRunZongDan",
              name: "DailiShangFengRunZongDan",
              meta: { title: "分润总单", id: "57" },
              component: resolve =>
                require([
                  "../components/pay/DailiShang/FengRunZongDan.vue"
                ], resolve)
            },
            {
              path: "DailiShangShengHuFenRun",
              name: "DailiShangShengHuFenRun",
              meta: { title: "分润配置", id: "58" },
              component: resolve =>
                require([
                  "../components/pay/DailiShang/ShangHuFenRun.vue"
                ], resolve)
            },
            {
              path: "FuZhuGongNengGuangGaoGuanLi",
              name: "FuZhuGongNengGuangGaoGuanLi",
              meta: { title: "广告管理", id: "59" },
              component: resolve =>
                require([
                  "../components/pay/FuZhuGongNeng/GuangGaoGuanLi.vue"
                ], resolve)
            },
            // 电子签
            {
              path: "DianZiQianHeTongGuanLi",
              name: "DianZiQianHeTongGuanLi",
              meta: { title: "合同管理", id: "61" },
              component: resolve =>
                require([
                  "../components/pay/DianZiQian/HeTongGuanLi.vue"
                ], resolve)
            },
            {
              path: "DianZiQianMaoBanGuanLi",
              name: "DianZiQianMaoBanGuanLi",
              meta: { title: "模版管理", id: "62" },
              component: resolve =>
                require([
                  "../components/pay/DianZiQian/MaoBanGuanLi.vue"
                ], resolve)
            },
            {
              path: "DianZiQianChuangJianHeTong",
              name: "DianZiQianChuangJianHeTong",
              meta: { title: "创建合同", id: "62" },
              component: resolve =>
                require([
                  "../components/pay/DianZiQian/ChuangJianHeTong.vue"
                ], resolve)
            }
          ]
        },
        // 进件控台
        {
          path: "jinjian",
          name: "jinjian",
          component: resolve =>
            require(["../components/jinjian/root.vue"], resolve),
          children: [
            {
              path: "ShangHuLieBiao",
              name: "jinjianShangHuLieBiao",
              meta: { title: "资料列表", id: "8" },
              component: resolve =>
                require(["../components/jinjian/ShangHu/LieBiao.vue"], resolve)
            },
            {
              path: "ShangHuXinZeng",
              name: "jinjianShangHuXinZeng",
              meta: { title: "新增资料", id: "8" },
              component: resolve =>
                require(["../components/jinjian/ShangHu/XinZeng.vue"], resolve)
            },
            {
              path: "ShangHuBianJi",
              name: "jinjianShangHuBianJi",
              meta: { title: "编辑资料", id: "8" },
              component: resolve =>
                require(["../components/jinjian/ShangHu/BianJi.vue"], resolve)
            },
            {
              path: "ShangHuRiZhi",
              name: "jinjianShangHuRiZhi",
              meta: { title: "进件日志", id: "9" },
              component: resolve =>
                require(["../components/jinjian/ShangHu/RiZhi.vue"], resolve)
            },
            {
              path: "YinShengLieBiao",
              name: "jinjianYinShengLieBiao",
              meta: { title: "进件列表", id: "10" },
              component: resolve =>
                require(["../components/jinjian/YinSheng/LieBiao.vue"], resolve)
            },
            {
              path: "YinShengDiQv",
              name: "jinjianYinShengDiQv",
              meta: { title: "地区列表", id: "10" },
              component: resolve =>
                require(["../components/jinjian/YinSheng/DiQv.vue"], resolve)
            },
            {
              path: "YinShengYinHang",
              name: "jinjianYinShengYinHang",
              meta: { title: "银行列表", id: "10" },
              component: resolve =>
                require(["../components/jinjian/YinSheng/YinHang.vue"], resolve)
            },
            {
              path: "YiBaoLieBiao",
              name: "jinjianYiBaoLieBiao",
              meta: { title: "进件列表", id: "11" },
              component: resolve =>
                require(["../components/jinjian/YiBao/LieBiao.vue"], resolve)
            },
            {
              path: "YiBaoDiQv",
              name: "jinjianYiBaoDiQv",
              meta: { title: "地区列表", id: "14" },
              component: resolve =>
                require(["../components/jinjian/YiBao/DiQv.vue"], resolve)
            },
            {
              path: "YiBaoYinHang",
              name: "jinjianYiBaoYinHang",
              meta: { title: "银行列表", id: "15" },
              component: resolve =>
                require(["../components/jinjian/YiBao/YinHang.vue"], resolve)
            },
            {
              path: "YiBaoZhangHu",
              name: "jinjianYiBaoZhangHu",
              meta: { title: "商户列表", id: "29" },
              component: resolve =>
                require(["../components/jinjian/YiBao/ZhangHu.vue"], resolve)
            },
            {
              path: "YiBaoFuWuShang",
              name: "jinjianYiBaoFuWuShang",
              meta: { title: "服务商", id: "30" },
              component: resolve =>
                require(["../components/jinjian/YiBao/FuWuShang.vue"], resolve)
            },
            {
              path: "YiBaoShangHuJieGouTu",
              name: "jinjianYiBaoShangHuJieGouTu",
              meta: { title: "商户结构图", id: "37" },
              component: resolve =>
                require([
                  "../components/jinjian/YiBao/ShangHuJieGouTu.vue"
                ], resolve)
            },
            {
              path: "FuYouLieBiao",
              name: "jinjianFuYouLieBiao",
              meta: { title: "进件列表", id: "16" },
              component: resolve =>
                require(["../components/jinjian/FuYou/LieBiao.vue"], resolve)
            },
            {
              path: "FuYouDiQv",
              name: "jinjianFuYouDiQv",
              meta: { title: "地区列表", id: "17" },
              component: resolve =>
                require(["../components/jinjian/FuYou/DiQv.vue"], resolve)
            },
            {
              path: "FuYouYinHang",
              name: "jinjianFuYouYinHang",
              meta: { title: "银行列表", id: "18" },
              component: resolve =>
                require(["../components/jinjian/FuYou/YinHang.vue"], resolve)
            },
            {
              path: "FuYouFeiLv",
              name: "jinjianFuYouFeiLv",
              meta: { title: "费率列表", id: "28" },
              component: resolve =>
                require(["../components/jinjian/FuYou/FeiLv.vue"], resolve)
            },
            // 汇付
            // {
            //   path: "HuiFuLieBiao",
            //   name: "jinjianHuiFuLieBiao",
            //   meta: { title: "进件列表", id: "19" },
            //   component: resolve =>
            //     require(["../components/jinjian/HuiFu/LieBiao.vue"], resolve)
            // },
            // {
            //   path: "HuiFuDiQv",
            //   name: "jinjianHuiFuDiQv",
            //   meta: { title: "地区列表", id: "20" },
            //   component: resolve =>
            //     require(["../components/jinjian/HuiFu/DiQv.vue"], resolve)
            // },
            // {
            //   path: "HuiFuYinHang",
            //   name: "jinjianHuiFuYinHang",
            //   meta: { title: "银行列表", id: "21" },
            //   component: resolve =>
            //     require(["../components/jinjian/HuiFu/YinHang.vue"], resolve)
            // },
            // {
            //   path: "HuiFuAPP",
            //   name: "jinjianHuiFuAPP",
            //   meta: { title: "汇付APP", id: "31" },
            //   component: resolve =>
            //     require(["../components/jinjian/HuiFu/APP.vue"], resolve)
            // },
            // 融宝
            // {
            //   path: "RongBaoLieBiao",
            //   name: "jinjianRongBaoLieBiao",
            //   meta: { title: "进件列表", id: "22" },
            //   component: resolve =>
            //     require(["../components/jinjian/RongBao/LieBiao.vue"], resolve)
            // },
            // {
            //   path: "RongBaoDiQv",
            //   name: "jinjianRongBaoDiQv",
            //   meta: { title: "地区列表", id: "23" },
            //   component: resolve =>
            //     require(["../components/jinjian/RongBao/DiQv.vue"], resolve)
            // },
            // {
            //   path: "RongBaoYinHang",
            //   name: "jinjianRongBaoYinHang",
            //   meta: { title: "银行列表", id: "24" },
            //   component: resolve =>
            //     require(["../components/jinjian/RongBao/YinHang.vue"], resolve)
            // },
            // 易生
            // {
            //   path: "YiShengLieBiao",
            //   name: "jinjianYiShengLieBiao",
            //   meta: { title: "进件列表", id: "25" },
            //   component: resolve =>
            //     require(["../components/jinjian/YiSheng/LieBiao.vue"], resolve)
            // },
            // {
            //   path: "YiShengDiQv",
            //   name: "jinjianYiShengDiQv",
            //   meta: { title: "地区列表", id: "26" },
            //   component: resolve =>
            //     require(["../components/jinjian/YiSheng/DiQv.vue"], resolve)
            // },
            // {
            //   path: "YiShengYinHang",
            //   name: "jinjianYiShengYinHang",
            //   meta: { title: "银行列表", id: "27" },
            //   component: resolve =>
            //     require(["../components/jinjian/YiSheng/YinHang.vue"], resolve)
            // },
            // 丰付
            // {
            //   path: "FengFuLieBiao",
            //   name: "jinjianFengFuLieBiao",
            //   meta: { title: "进件列表", id: "32" },
            //   component: resolve =>
            //     require(["../components/jinjian/FengFu/LieBiao.vue"], resolve)
            // },
            // {
            //   path: "FengFuDiQv",
            //   name: "jinjianFengFuDiQv",
            //   meta: { title: "地区列表", id: "33" },
            //   component: resolve =>
            //     require(["../components/jinjian/FengFu/DiQv.vue"], resolve)
            // },
            // {
            //   path: "FengFuYinHang",
            //   name: "jinjianFengFuYinHang",
            //   meta: { title: "银行列表", id: "34" },
            //   component: resolve =>
            //     require(["../components/jinjian/FengFu/YinHang.vue"], resolve)
            // },
            // {
            //   path: "FengFuShangHu",
            //   name: "jinjianFengFuShangHu",
            //   meta: { title: "丰付商户", id: "35" },
            //   component: resolve =>
            //     require(["../components/jinjian/FengFu/ShangHu.vue"], resolve)
            // },
            // 商盟
            // {
            //   path: "ShangMengLieBiao",
            //   name: "jinjianShangMengLieBiao",
            //   meta: { title: "进件列表", id: "38" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/ShangMeng/LieBiao.vue"
            //     ], resolve)
            // },
            // {
            //   path: "ShangMengDiQv",
            //   name: "jinjianShangMengDiQv",
            //   meta: { title: "地区列表", id: "40" },
            //   component: resolve =>
            //     require(["../components/jinjian/ShangMeng/DiQv.vue"], resolve)
            // },
            // {
            //   path: "ShangMengYinHang",
            //   name: "jinjianShangMengYinHang",
            //   meta: { title: "银行列表", id: "41" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/ShangMeng/YinHang.vue"
            //     ], resolve)
            // },
            // {
            //   path: "ShangMengmcc",
            //   name: "jinjianShangMengmcc",
            //   meta: { title: "商盟mcc表", id: "42" },
            //   component: resolve =>
            //     require(["../components/jinjian/ShangMeng/mcc.vue"], resolve)
            // },
            // {
            //   path: "ShangMengErJiLeiMu",
            //   name: "jinjianShangMengErJiLeiMu",
            //   meta: { title: "二级类目表", id: "43" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/ShangMeng/ErJiLeiMu.vue"
            //     ], resolve)
            // },
            // {
            //   path: "ShangMengFuWuShang",
            //   name: "jinjianShangMengFuWuShang",
            //   meta: { title: "服务商", id: "44" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/ShangMeng/FuWuShang.vue"
            //     ], resolve)
            // },
            // {
            //   path: "ShangMengFengKong",
            //   name: "jinjianShangMengFengKong",
            //   meta: { title: "风控列表", id: "50" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/ShangMeng/FengKong.vue"
            //     ], resolve)
            // },
            // 智付
            // {
            //   path: "ZhiFuLieBiao",
            //   name: "jinjianZhiFuLieBiao",
            //   meta: { title: "进件列表", id: "45" },
            //   component: resolve =>
            //     require(["../components/jinjian/ZhiFu/LieBiao.vue"], resolve)
            // },
            // {
            //   path: "ZhiFuDiQv",
            //   name: "jinjianZhiFuDiQv",
            //   meta: { title: "地区列表", id: "46" },
            //   component: resolve =>
            //     require(["../components/jinjian/ZhiFu/DiQv.vue"], resolve)
            // },
            // {
            //   path: "ZhiFuYinHang",
            //   name: "jinjianZhiFuYinHang",
            //   meta: { title: "银行列表", id: "47" },
            //   component: resolve =>
            //     require(["../components/jinjian/ZhiFu/YinHang.vue"], resolve)
            // },
            // {
            //   path: "ZhiFuErJiLeiMu",
            //   name: "jinjianZhiFuErJiLeiMu",
            //   meta: { title: "二级类目表", id: "48" },
            //   component: resolve =>
            //     require(["../components/jinjian/ZhiFu/ErJiLeiMu.vue"], resolve)
            // },
            // {
            //   path: "ZhiFuFuWuSang",
            //   name: "jinjianZhiFuFuWuSang",
            //   meta: { title: "服务商", id: "51" },
            //   component: resolve =>
            //     require(["../components/jinjian/ZhiFu/FuWuSang.vue"], resolve)
            // },
            // {
            //   path: "ZhiFuPeiZhi",
            //   name: "jinjianZhiFuPeiZhi",
            //   meta: { title: "产品配置", id: "52" },
            //   component: resolve =>
            //     require(["../components/jinjian/ZhiFu/PeiZhi.vue"], resolve)
            // },
            // {
            //   path: "ZhiFuBaoBeiHao",
            //   name: "jinjianZhiFuBaoBeiHao",
            //   meta: { title: "报备号列表", id: "53" },
            //   component: resolve =>
            //     require(["../components/jinjian/ZhiFu/BaoBeiHao.vue"], resolve)
            // },

            // 银盛e企通
            // {
            //   path: "YinShengEQiTongLieBiao",
            //   name: "jinjianYinShengEQiTongLieBiao",
            //   meta: { title: "进件列表", id: "58" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/YinShengEQiTong/LieBiao.vue"
            //     ], resolve)
            // },
            // {
            //   path: "YinShengEQiTongJieSuanXiuGaiJiLu",
            //   name: "jinjianYinShengEQiTongJieSuanXiuGaiJiLu",
            //   meta: { title: "结算修改记录", id: "59" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/YinShengEQiTong/JieSuanXiuGaiJiLu.vue"
            //     ], resolve)
            // },
            // 银盈通
            // {
            //   path: "YinYingTongLieBiao",
            //   name: "jinjianYinYingTongLieBiao",
            //   meta: { title: "进件列表", id: "61" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/YinYingTong/LieBiao.vue"
            //     ], resolve)
            // },

            // 新易生
            // {
            //   path: "NewYiShengLieBiao",
            //   name: "jinjianNewYiShengLieBiao",
            //   meta: { title: "进件列表", id: "65" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/NewYiSheng/LieBiao.vue"
            //     ], resolve)
            // },
            // {
            //   path: "NewYiShengShangHuMcc",
            //   name: "jinjianNewYiShengShangHuMcc",
            //   meta: { title: "商户MCC", id: "67" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/NewYiSheng/ShangHuMcc.vue"
            //     ], resolve)
            // },
            // {
            //   path: "NewYiShengZhiFuBaoMcc",
            //   name: "jinjianNewYiShengZhiFuBaoMcc",
            //   meta: { title: "支付宝MCC", id: "68" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/NewYiSheng/ZhiFuBaoMcc.vue"
            //     ], resolve)
            // },
            // {
            //   path: "NewYiShengWeiXinMcc",
            //   name: "jinjianNewYiShengWeiXinMcc",
            //   meta: { title: "微信MCC", id: "69" },
            //   component: resolve =>
            //     require([
            //       "../components/jinjian/NewYiSheng/WeiXinMcc.vue"
            //     ], resolve)
            // },
            // 签约
            {
              path: "QianYueLieBiao",
              name: "jinjianQianYueLieBiao",
              meta: { title: "分配列表", id: "55" },
              component: resolve =>
                require(["../components/jinjian/QianYue/LieBiao.vue"], resolve)
            },
            {
              path: "QianYueYiFengPeiLieBiao",
              name: "jinjianQianYueYiFengPeiLieBiao",
              meta: { title: "已分配列表", id: "56" },
              component: resolve =>
                require([
                  "../components/jinjian/QianYue/YiFengPeiLieBiao.vue"
                ], resolve)
            },
            // 鲲鹏
            {
              path: "KunPengLieBiao",
              name: "jinjianKunPengLieBiao",
              meta: { title: "进件列表", id: "63" },
              component: resolve =>
                require(["../components/jinjian/KunPeng/LieBiao.vue"], resolve)
            },
            {
              path: "KunPengATList",
              name: "jinjianKunPengATList",
              meta: { title: "AT列表", id: "66" },
              component: resolve =>
                require(["../components/jinjian/KunPeng/ATList.vue"], resolve)
            },
            {
              path: "KunPengDiQv",
              name: "jinjianKunPengDiQv",
              meta: { title: "地区列表 ", id: "70" },
              component: resolve =>
                require(["../components/jinjian/KunPeng/DiQv.vue"], resolve)
            },
            {
              path: "KunPengRiZhi",
              name: "jinjianKunPengRiZhi",
              meta: { title: "修改日志", id: "71" },
              component: resolve =>
                require(["../components/jinjian/KunPeng/RiZhi.vue"], resolve)
            },
            {
              path: "KunPengZhiFuBao",
              name: "jinjianKunPengZhiFuBao",
              meta: { title: "支付宝服务商", id: "72" },
              component: resolve =>
                require(["../components/jinjian/KunPeng/ZhiFuBao.vue"], resolve)
            },
            {
              path: "KunPengWeiXin",
              name: "jinjianKunPengWeiXin",
              meta: { title: "微信服务商", id: "73" },
              component: resolve =>
                require(["../components/jinjian/KunPeng/WeiXin.vue"], resolve)
            },
            // 中科易付
            {
              path: "ZhongKeYiFuLieBiao",
              name: "jinjianZhongKeYiFuLieBiao",
              meta: { title: "进件列表", id: "75" },
              component: resolve =>
                require([
                  "../components/jinjian/ZhongKeYiFu/LieBiao.vue"
                ], resolve)
            },
            {
              path: "ZhongKeYiFuShangHu",
              name: "jinjianZhongKeYiFuShangHu",
              meta: { title: "商户列表", id: "76" },
              component: resolve =>
                require([
                  "../components/jinjian/ZhongKeYiFu/ShangHu.vue"
                ], resolve)
            },
            {
              path: "ZhongKeYiFuMengDian",
              name: "jinjianZhongKeYiFuMengDian",
              meta: { title: "门店列表", id: "77" },
              component: resolve =>
                require([
                  "../components/jinjian/ZhongKeYiFu/MengDian.vue"
                ], resolve)
            },
            {
              path: "ZhongKeYiFuQuDaoRenZheng",
              name: "jinjianZhongKeYiFuQuDaoRenZheng",
              meta: { title: "渠道认证", id: "78" },
              component: resolve =>
                require([
                  "../components/jinjian/ZhongKeYiFu/QuDaoRenZheng.vue"
                ], resolve)
            }
          ]
        },
        // 系统
        {
          path: "system",
          name: "system",
          component: resolve =>
            require(["../components/system/root.vue"], resolve),
          children: [
            {
              path: "index",
              name: "systemIndex",
              meta: { title: "主页", id: "0" },
              component: resolve =>
                require(["../components/system/index/index.vue"], resolve)
            }
          ]
        }
      ]
    }
  ]
});
vuerouter.beforeEach((to, from, next) => {
  let url = next();
  if (
    to.name != "login" &&
    to.name != "WaiBuJinJian" &&
    !window.localStorage.getItem("$token")
  ) {
    url = next("/");
  }
  return url;
});
export default vuerouter;



// WEBPACK FOOTER //
// ./src/router/index.js